import { ProductValidationSchema } from '@/features/products/schemas/create.schema'
import { ProductData } from '@/features/products/types/product'

export const updateProductTefIdentifierValue = ({
  tefIdentifiers,
  product,
}: {
  tefIdentifiers: ProductValidationSchema['product_tef_identifiers']
  product?: ProductData
}) =>
  (product?.product_tef_identifiers || [])
    .filter((existingTefIdentifier) => {
      const updatedTefIdentifier = tefIdentifiers?.find(
        (tefIdentifier) => tefIdentifier.identifier_id === existingTefIdentifier.id,
      )
      return (
        (updatedTefIdentifier && updatedTefIdentifier.identifier !== existingTefIdentifier.identifier) ||
        updatedTefIdentifier?.tef_provider?.value !== existingTefIdentifier.tef_provider
      )
    })
    .map((existingTefIdentifier) => {
      const updatedTefIdentifier = tefIdentifiers?.find(
        (tefIdentifier) => tefIdentifier.identifier_id === existingTefIdentifier.id,
      )

      return {
        id: existingTefIdentifier.id,
        tef_provider: updatedTefIdentifier?.tef_provider?.value,
        identifier: updatedTefIdentifier?.identifier,
      }
    })
